<template>
  <Viewer ref="toastUiViewer" :options="options" :initialValue="text"></Viewer>
</template>
<script>
import '@toast-ui/editor/dist/toastui-editor.css'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css'

import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
import '@toast-ui/editor-plugin-code-syntax-highlight/dist/toastui-editor-plugin-code-syntax-highlight.css'

import 'tui-color-picker/dist/tui-color-picker.css'
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css'
//note: disabled for now due to bug
//https://github.com/nhn/tui.editor/issues/1589
// import colorSyntax from '@toast-ui/editor-plugin-color-syntax'

import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight/dist/toastui-editor-plugin-code-syntax-highlight-all.js'
import tableMergedCell from '@toast-ui/editor-plugin-table-merged-cell'

import { Viewer } from '@toast-ui/vue-editor'
import youtubePlugin from '@src/plugins/tuiYoutube'

import DOMPurify from 'dompurify'

// Add a hook to make all links open a new window
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank')
  }
  // set non-HTML/MathML links to xlink:show=new
  if (
    !node.hasAttribute('target') &&
    (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
  ) {
    node.setAttribute('xlink:show', 'new')
  }
})
export default {
  model: {
    prop: 'text',
    event: 'change',
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  components: { Viewer },
  filters: {},
  data() {
    return {}
  },
  updated() {},
  computed: {
    options() {
      //avoid sanitization of html from plugins (youtubePlugin iframe specifically)
      //we are only doing this in the viewer as in the editor the
      //customHTMLRenderer is able to render the iframes
      var purifyOptions = {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
        FORBID_TAGS: [
          'script',
          'textarea',
          'form',
          'button',
          'select',
          'input',
          'meta',
          'style',
          'link',
          'title',
          'embed',
          'object',
          'details',
          'summary',
        ],
      }
      return {
        usageStatistics: false,
        plugins: [
          [codeSyntaxHighlight, { highlighter: Prism }],
          // colorSyntax,
          tableMergedCell,
          [youtubePlugin, { width: 375 }],
        ],
        customHTMLSanitizer: (html) => {
          return DOMPurify.sanitize(html, purifyOptions) || ''
        },
        // theme: this.$vuetify.theme.dark ? 'dark' : '',
      }
    },
  },
  methods: {},
  watch: {
    text(nval, oval) {
      this.$refs.toastUiViewer.invoke('setMarkdown', nval)
    },
  },
}
</script>
<style>
/* remove text shadow - looks weird in dark mode */
code[class*='language-'],
pre[class*='language-'] {
  text-shadow: none !important;
}
/* .token.operator has weird background in dark mode */
.token {
  background: none !important;
}
/* .token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  background: hsla(0, 0%, 100%, 0.5);
} */

/* vuetify has different background color for code elements */
.toastui-editor-contents pre code {
  background-color: unset !important;
}
</style>
